import _extends from "@babel/runtime/helpers/esm/extends";

/* eslint-disable import/order */
// This file has been generated using @svgr/cli.
// Run "yarn generate:icons" in order to generate the files for new icons.
import * as React from 'react';
import styled from 'styled-components';
import { size, color } from 'styled-system';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M6.808 42.87C11.365 44.291 16.97 45 23.63 45s12.266-.708 16.823-2.13a4 4 0 0 0 2.753-4.475l-.844-5.073a7 7 0 0 0-6.3-5.826C32.24 27.167 28.096 27 23.63 27c-4.467 0-8.61.165-12.432.497a7 7 0 0 0-6.3 5.825l-.844 5.073a4 4 0 0 0 2.753 4.474ZM23.63 3c-5.523 0-10 4.477-10 10 0 5.524 4.478 10 10 10 5.524 0 10-4.477 10-10 0-5.524-4.476-10-10-10Z",
    fill: "currentColor"
  }));
};

var SvgUser = styled(SvgComponent).withConfig({
  displayName: "User__SvgUser",
  componentId: "sc-10ojb8x-0"
})(["", " ", ""], size, color);
export default SvgUser;